import { z } from 'zod';

export const selfCheckoutDataSchema = z.object({
  earlyOptOut: z.boolean(),
  minimumContractDurationMonths: z.number().min(0, { message: 'Die Laufzeit muss mindestens 0 Monate betragen' }),
  packageName: z.string().min(1, { message: 'Der Paketname ist erforderlich' }),
  packagePrice: z.number().min(0, { message: 'Der Paketpreis muss mindestens 0 Euro betragen' }),
  allowedJobsCount: z.number().min(1, { message: 'Die Kapazität muss mindestens 1 betragen' }),
  trialStartAt: z.string().optional(),
  additionalConditions: z.string().optional().nullable(),
  additionalPriceConditions: z.string().optional().nullable()
});

export type SelfCheckoutDataSchemaType = z.infer<typeof selfCheckoutDataSchema>;
